import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../../global';
import { environment } from '../../../environments/environment';
import {
  AscBasicInfo,
  TimesheetBasicInfo,
  TimesheetOverview,
  TimesheetLineItem,
  TimesheetSummary,
  TimesheetComments
} from '../models/ts-info.model';

@Injectable({
  providedIn: 'root'
})
export class TsInfoService {
  private apiUrl = environment.useApiGateway
    ? environment.apiGatewayUrl
    : GlobalVariable.BASE_URL;

  constructor(private http: HttpClient) { }

  // ASC情報を取得（登録番号またはUQで検索）
  getAscInfo(userCode?: string, userId?: number): Observable<AscBasicInfo | null> {
    let params = new HttpParams();
    if (userCode) {
      params = params.set('userCode', userCode);
    } else if (userId) {
      params = params.set('userId', userId.toString());
    }
    const endpoint = environment.useApiGateway ? '/tsinfo/asc-info' : '/TsInfo/asc-info';
    return this.http.get<AscBasicInfo | null>(`${this.apiUrl}${endpoint}`, { params });
  }

  // 指定ユーザー・年月のタイムシート一覧を取得
  getTimesheets(staffId: number, yearMonth: string): Observable<TimesheetBasicInfo[]> {
    const params = new HttpParams()
      .set('staffId', staffId.toString())
      .set('yearMonth', yearMonth);
    const endpoint = environment.useApiGateway ? '/tsinfo/timesheets' : '/TsInfo/timesheets';
    return this.http.get<TimesheetBasicInfo[]>(`${this.apiUrl}${endpoint}`, { params });
  }

  // スタッフが持つタイムシートの年月リストを取得（現役・BK両テーブル、降順）
  getYearMonthList(staffId: number): Observable<string[]> {
    const params = new HttpParams().set('staffId', staffId.toString());
    const endpoint = environment.useApiGateway ? '/tsinfo/year-month-list' : '/TsInfo/year-month-list';
    return this.http.get<string[]>(`${this.apiUrl}${endpoint}`, { params });
  }

  // タイムシート概要情報を取得
  getTimesheetOverview(timesheetId: number): Observable<TimesheetOverview> {
    const endpoint = environment.useApiGateway ? '/tsinfo/overview' : '/TsInfo/overview';
    return this.http.get<TimesheetOverview>(`${this.apiUrl}${endpoint}/${timesheetId}`);
  }

  // タイムシート明細を取得
  getTimesheetLineItems(timesheetId: number): Observable<TimesheetLineItem[]> {
    const endpoint = environment.useApiGateway ? '/tsinfo/line-items' : '/TsInfo/line-items';
    return this.http.get<TimesheetLineItem[]>(`${this.apiUrl}${endpoint}/${timesheetId}`);
  }

  // タイムシートサマリーを取得
  getTimesheetSummary(timesheetId: number): Observable<TimesheetSummary> {
    const endpoint = environment.useApiGateway ? '/tsinfo/summary' : '/TsInfo/summary';
    return this.http.get<TimesheetSummary>(`${this.apiUrl}${endpoint}/${timesheetId}`);
  }

  // タイムシートコメントを取得
  getTimesheetComments(timesheetId: number): Observable<TimesheetComments> {
    const endpoint = environment.useApiGateway ? '/tsinfo/comments' : '/TsInfo/comments';
    return this.http.get<TimesheetComments>(`${this.apiUrl}${endpoint}/${timesheetId}`);
  }
}
